<template>
  <div class="evaluate-edit-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" :showBack="true" class="top-title" title="修改评分"></my-header>
    <div class="client-evaluate-form">
      <div class="evaluate-header-title">
        项目评价
      </div>
      <div class="evaluate-text">
        <textarea rows="5" v-model="content" placeholder="评价只能修改一次 请您谨慎填写"></textarea>
      </div>
      <div class="footer">
        <div>总体评分</div>
        <div class="evaluate-star">
          <div class="star-img" v-model="score" :class="score <= 0 ? '' : (score >=1 ? 'on': 'off')" @click="selectScore(1)"></div>
          <div class="star-img" v-model="score" :class="score <= 1 ? '' : (score >=2 ? 'on': 'off')" @click="selectScore(2)"></div>
          <div class="star-img" v-model="score" :class="score <= 2 ? '' : (score >=3 ? 'on': 'off')" @click="selectScore(3)"></div>
          <div class="star-img" v-model="score" :class="score <= 3 ? '' : (score >=4 ? 'on': 'off')" @click="selectScore(4)"></div>
          <div class="star-img" v-model="score" :class="score <= 4 ? '' : (score >=5 ? 'on': 'off')" @click="selectScore(5)"></div>
        </div>
      </div>
      <div class="evaluate-btn" @click="save()">提&nbsp;&nbsp;交</div>
      <div class="clear"></div>
      <div v-if="showTip" class="toast general-tip-modal">
        <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closeTip()">
        <div class="general-modal-title border-bottom-style">温馨提示</div>
        <div class="general-modal-msg">您还未选择评分<br/>请您评分完成再提交评价!</div>
        <div class="agree-btn" @click="closeTip()">确定</div>
      </div>
      <div v-if="showTip" class="pay-box"></div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import evaluateService from '../../service/customer/EvaluateService'

  export default {
    name: 'CustomerEvaluateEdit',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        id:'',
        content:'',
        score:0,
        evaluate:'',
        showTip:false,
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.id = this.$route.query.id;
      this.loadEvaluateDetail();
    },
    methods: {
      async loadEvaluateDetail() {
        let {code, data:evaluate} = await evaluateService.detail(this.id);
        if(code == '0'){
          this.content = evaluate.content || '';
          this.score = evaluate.score;
        }else {
          Toast('获取评价信息失败');
        }
      },
      selectScore(score){
        this.score = score;
      },
      async save(){
        if(this.score == 0){
          this.showTip = true;
          return;
        }
        let {code} = await evaluateService.update(this.id,this.score,this.content);
        if(code == '0'){
          Toast('评价修改成功!');
          this.$router.go(-1);
        }else{
          Toast('修改评价失败,请稍后重试!');
        }
      },
      closeTip(){
        this.showTip = false;
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/style/common.scss';
  .client-evaluate-form{
    width: 6.9rem;
    margin: 0 auto;
    padding: 0 0.28rem;
    background-color: white;
    .evaluate-header-title{
      height: 0.78rem;
      display: flex;
      align-items: center;
      font-weight: bold;
    }
    .evaluate-text{
      width: 100%;
      textarea{
        width: calc(100% - 0.57rem);
        height: 1.77rem;
        color: #1B1E29;
        line-height: 0.42rem;
        background-color: #f7f6f5;
        padding: 0.23rem 0.23rem 0.23rem 0.34rem;
        resize: none;
        outline: none;
        font-size: 0.32rem;
        ::placeholder{
          color: #cecbca;
        }
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
    }
    .evaluate-star{
      display: flex;
      align-items: center;
      font-weight: bold;
    }
    .star-img {
      width: 0.32rem;
      height: 0.3rem;
      margin-left: 0.1rem;
      background-image: url("../../assets/icon/icon-star-off.png");
      background-size: 100%;
    }
    .on{
      background-image: url("../../assets/icon/icon-star-on.png");
    }
    .off{
      background-image: url("../../assets/icon/icon-star-off.png");
    }
    .evaluate-btn{
      float: right;
      width: 1.68rem;
      height: 0.6rem;
      margin-top: 0.4rem;
      margin-bottom: 1.17rem;
      background-color: #feac00;
      text-align: center;
      line-height: 0.6rem;
      border-radius: 1rem;
      color: white;
      font-size: 0.32rem;
    }
  }
</style>
